import { render, staticRenderFns } from "./TemplateTurnoverCard.vue?vue&type=template&id=075a1c32&"
import script from "./TemplateTurnoverCard.vue?vue&type=script&lang=js&"
export * from "./TemplateTurnoverCard.vue?vue&type=script&lang=js&"
import style0 from "./TemplateTurnoverCard.vue?vue&type=style&index=0&id=075a1c32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports